import { render, staticRenderFns } from "./DevBpbjLeadoutRecordForm.vue?vue&type=template&id=510664ec&"
import script from "./DevBpbjLeadoutRecordForm.vue?vue&type=script&lang=js&"
export * from "./DevBpbjLeadoutRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports